import type { RootState } from '@/store/store';

export const selectSeoSettings = (state: RootState) => state.pages.currentPage?.seoSettings;
